import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=07b7598c&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=js&"
export * from "./Note.vue?vue&type=script&lang=js&"
import style0 from "./Note.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Note.vue?vue&type=style&index=1&id=07b7598c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7598c",
  null
  
)

export default component.exports